import request from '@services/request';
import Encrypt from '@shared/utils/encodingUtils';

export const getAllRoles = async () => {
  try {
    const response = await request.get('/api/v1/corresponsal/roles');
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllRolesByCorrespondent = async (
  search = {},
  fetchAll = 0,
  page = 1,
  size = 3,
  sortBy = null,
  sortDirection = null
) => {
  try {
    const params = {
      role_id: search.role_id || null,
      role_name: search.role_name || null,
      correspondent_type_name: search.correspondent_types || null,
      limit: size,
      offset: page,
      fetchAll,
      sortBy: sortBy || null,
      sortDirection: sortDirection || null,
    };

    const response = await request.get('/api/v1/corresponsal/correspondent-role', params);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRolesByCorrespondentId = (correspondentId) => {
  const encodeCorrespondentId = Encrypt.encode(correspondentId);
  return request.get(`/api/v1/corresponsal/correspondents/${encodeCorrespondentId}/roles`);
};

export const getCorrespondentRoles = () => {
  return request
    .get('/api/v1/corresponsal/roles/correspondents')
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getRolesByCorrespondentType = (correspondentTypeId) => {
  return request
    .get(`/api/v1/corresponsal/roles/crsp/${correspondentTypeId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteRoleByCorresondent = async (crspTypeId, roleId) => {
  const result = await request.put(`/api/v1/corresponsal/roles/crsp/${crspTypeId}/${roleId}`);
  const { data } = result;
  return data;
};

export const assignRoleByCorrespondent = async (body) => {
  const result = await request.post('/api/v1/corresponsal/roles/crsp', body);
  const { data } = result;
  return data;
};

export const createCorrespondentTypeRole = async (body) => {
  const result = await request.post('/api/v1/corresponsal/roles/correspondent-type', body);
  const { data } = result;
  return data;
};

export const updateCorrespondentTypeRole = async (body) => {
  const result = await request.put('/api/v1/corresponsal/roles/correspondent-type', body);
  const { data } = result;
  return data;
};

export const roleNameAlreadyExists = async (roleName) => {
  const result = await request.get('/api/v1/corresponsal/roles/exists', { name: roleName });
  const { data } = result;
  return data;
};

export const deleteRoleByCorrespondentType = async (roleId) => {
  const result = await request.methodDelete(`/api/v1/corresponsal/roles/${roleId}`);
  const { data } = result;
  return data;
};
